var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto px-5 pb-5 mt-10",attrs:{"flat":"","max-width":"680"}},[_c('v-window',{attrs:{"value":_vm.step}},[_c('v-window-item',{attrs:{"value":"signin"}},[_c('Signin')],1),_c('v-window-item',{attrs:{"value":"recover"}},[_c('RecoverPassword')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }